import { useQuery } from "@tanstack/react-query";

import { listSoilSightScenarios } from "services";

import { useIsAuthenticated } from "utils";

import { LIST_SOIL_SIGHT_SCENARIOS } from "consts";

import { SoilSightScenario } from "models";

export const useListSoilSightScenarios = (soilSightProjectId: string) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightScenario[]>({
    queryKey: [LIST_SOIL_SIGHT_SCENARIOS, soilSightProjectId],
    queryFn: () => listSoilSightScenarios(soilSightProjectId),
    staleTime: 1000 * 60 * 5,
    enabled: isAuthenticated && !!soilSightProjectId,
  });
};
